import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Help = loadable(() => pMinDelay(import('./ChanceGamesHelp'), 300), {
  fallback: <Loading />
});

const AsyncHelp = props => {
  const pageConfig = {
    headerType: props?.userAgent?.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: props?.userAgent?.device?.type === 'desktop' ? 'full' : 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-solid-grey hide-betslip hide-sticky-navigation`
      },
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Help { ...props }/>
    </ApplicationLayout>
  );
};

AsyncHelp.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncHelp;
